"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var react_1 = __importDefault(require("react"));
function JetDropdownLink(_a) {
    var as = _a.as, href = _a.href, children = _a.children;
    return (react_1.default.createElement("div", null, (function () {
        switch (as) {
            case 'button':
                return (react_1.default.createElement("button", { type: "submit", className: "block w-full px-4 py-2 text-sm leading-5 text-gray-700 text-left hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition" }, children));
            case 'a':
                return (react_1.default.createElement("a", { href: href, className: "block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition" }, children));
            default:
                return (react_1.default.createElement(inertia_react_1.InertiaLink, { href: href || '', className: "block px-4 py-2 text-sm leading-5 text-gray-700 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 transition" }, children));
        }
    })()));
}
exports.default = JetDropdownLink;
